import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

export class answers{
  questionId?:String;
  description?: String;
  score?: String;
}

@Injectable({
  providedIn: 'root'
})
export class AnswersService {
  private apiURL = environment.api_cuestionarios_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public postAnswers(answer){
    const answ: answers = {
      questionId: answer.questionId,
      description: answer.respuesta,
      score: answer.score
    }
    const body = JSON.stringify(answ);
    const apiURL = this.apiURL+"answer-options";
    return this.http.post(`${apiURL}`,body, {headers: this.headers});
  }
  public updateAnswers(answer){
    const ques: answers = {
      description: answer.respuesta,
      score: answer.score
      
    }
    const body = JSON.stringify(ques);
    const apiURL = this.apiURL+"answer-options/"+answer.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public deleteAnswers(id: string) {
    const apiURL = this.apiURL+"answer-options/"+id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
    //return this.http.delete<string>(apiURL + id, {headers: this.headers});
  }
}